import { IRcaRepo } from "./irepo";
import {
  NodeNamesMap,
  RcaContext,
  GcmModel,
  DistributionsDef,
  AnomalyRangeDef,
  GcmAttributionDef,
  FitCausalMechanismDef,
  RcaDistributionsReq,
  RcaTrendReq,
  RcaTrendDef,
  RcaAnomalyScoreReq,
  RcaAnomalyRangeReq,
  GcmUpstreamInfluenceReq,
  GcmAnomalyAttributionReq,
  GcmDistributionChangeReq,
  RenameGcmReq,
} from "./type/rca-def";
import { TError } from "../../types/error";

export class RcaUsecase {
  private repo: IRcaRepo;
  private error: (error: TError) => void;

  constructor(repo: IRcaRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async fetchNodeNamesMap(asset_id: string): Promise<NodeNamesMap> {
    try {
      return await this.repo.fetchNodeNamesMap(asset_id);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchContext(asset_id: string): Promise<RcaContext> {
    try {
      return await this.repo.fetchContext(asset_id);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async listGcm(asset_id: string): Promise<GcmModel[]> {
    try {
      return await this.repo.listGcm(asset_id);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchDistributions(req: RcaDistributionsReq): Promise<DistributionsDef> {
    try {
      return await this.repo.fetchDistributions(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchTrend(req: RcaTrendReq): Promise<RcaTrendDef> {
    try {
      return await this.repo.fetchTrend(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchAnomalyScore(req: RcaAnomalyScoreReq): Promise<string> {
    try {
      return await this.repo.fetchAnomalyScore(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchAnomalyRange(req: RcaAnomalyRangeReq): Promise<AnomalyRangeDef> {
    try {
      return await this.repo.fetchAnomalyRange(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fitCausalMechanism(asset_id: string): Promise<FitCausalMechanismDef> {
    try {
      return await this.repo.fitCausalMechanism(asset_id);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async getUpstreamInfluence(req: GcmUpstreamInfluenceReq): Promise<GcmAttributionDef> {
    try {
      return await this.repo.getUpstreamInfluence(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async getAnomalyAttribution(req: GcmAnomalyAttributionReq): Promise<GcmAttributionDef> {
    try {
      return await this.repo.getAnomalyAttribution(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  // ===== POST のみ（task_id を返す）。UI で永続化＋ポーリングする用 =====
  async postFitCausalMechanism(asset_id: string, mode?: "advanced"): Promise<{ task_id: string }> {
    try {
      return await this.repo.postFitCausalMechanism(asset_id, mode);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async postUpstreamInfluence(req: GcmUpstreamInfluenceReq): Promise<{ task_id: string }> {
    try {
      return await this.repo.postUpstreamInfluence(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async postAnomalyAttribution(req: GcmAnomalyAttributionReq): Promise<{ task_id: string }> {
    try {
      return await this.repo.postAnomalyAttribution(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async getDistributionChange(req: GcmDistributionChangeReq): Promise<GcmAttributionDef> {
    try {
      return await this.repo.getDistributionChange(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async renameGcm(gcm_id: string, req: RenameGcmReq): Promise<string> {
    try {
      return await this.repo.renameGcm(gcm_id, req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async deleteGcm(gcm_id: string): Promise<string> {
    try {
      return await this.repo.deleteGcm(gcm_id);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }
}
